import { render, staticRenderFns } from "./label-editor.vue?vue&type=template&id=f1ed7b7a&scoped=true"
import script from "./label-editor.vue?vue&type=script&lang=js"
export * from "./label-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ed7b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ed7b7a')) {
      api.createRecord('f1ed7b7a', component.options)
    } else {
      api.reload('f1ed7b7a', component.options)
    }
    module.hot.accept("./label-editor.vue?vue&type=template&id=f1ed7b7a&scoped=true", function () {
      api.rerender('f1ed7b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/label-editor.vue"
export default component.exports